module.exports = __webpack_public_path__ + "img/EATechWord3.7e680469.png";